export default "__VITE_ASSET__DXkl4wcL__"